import React, { useState } from 'react';
import { opcionesPlan } from '../engine/matriz';
import { fmtPesos } from '../engine/perfil';

// S3 · El control depende de la ficha: tarjetas (planes cerrados), caja (rango abierto) o planes por edad.
// S2 · Solo muestra lo que el perfil permite comprar; el cliente no ve los planes ocultos.
export const PlanPicker = ({ id, answers, valor, onCambio, locked }) => {
  const op = opcionesPlan(id, answers);
  const [txt, setTxt] = useState(valor && valor.va && op && op.modo === 'caja' ? valor.va.toLocaleString('es-CO') : '');
  if (!op) return null;

  if (op.modo === 'caja') {
    const n = Number(txt.replace(/\D/g, '')) || 0;
    let aviso = null;
    if (n && n < op.min) aviso = `El mínimo es ${fmtPesos(op.min)}.`;
    else if (n > op.max) aviso = op.limitado
      ? `Con su perfil el máximo es ${fmtPesos(op.max)}. Si necesita más, un asesor lo revisa con usted.`
      : `El máximo es ${fmtPesos(op.max)}.`;
    const fijar = (v) => {
      setTxt(v ? v.toLocaleString('es-CO') : '');
      onCambio(v >= op.min && v <= op.max ? { label: fmtPesos(v), va: v } : null);
    };
    return (
      <div className="pp pp-caja" data-testid={`pp-${id}`}>
        <label className="pp-k" htmlFor={`pp-in-${id}`}>¿Cuánto quiere asegurar?</label>
        <div className="pp-in">
          <span>$</span>
          <input
            id={`pp-in-${id}`}
            inputMode="numeric"
            value={txt}
            disabled={locked}
            placeholder={op.min.toLocaleString('es-CO')}
            onChange={(e) => fijar(Number(e.target.value.replace(/\D/g, '')) || 0)}
            data-testid={`pp-input-${id}`}
          />
        </div>
        <div className="pp-rapidos">
          {op.rapidos.filter((v) => v <= op.max).map((v) => (
            <button key={v} type="button" disabled={locked} className={n === v ? 'on' : ''} onClick={() => fijar(v)}>{`$${v / 1e6} M`}</button>
          ))}
        </div>
        <span className="pp-rango">{`Entre ${fmtPesos(op.min)} y ${fmtPesos(op.max)}`}</span>
        {aviso ? <span className="pp-aviso" data-testid={`pp-aviso-${id}`}>{aviso}</span> : null}
      </div>
    );
  }

  if (op.sinBanda) return <span className="pp-rango">Primero indique su rango de edad.</span>;
  return (
    <div className="pp pp-lista" data-testid={`pp-${id}`}>
      <span className="pp-k">{op.modo === 'lista_por_edad' ? `Elija el valor (tarifa ${answers.edad} años)` : 'Elija el plan'}</span>
      {op.planes.map((p) => (
        <button
          key={p.id}
          type="button"
          disabled={locked}
          className={`pp-plan ${valor && valor.id === p.id ? 'on' : ''}`}
          aria-pressed={Boolean(valor && valor.id === p.id)}
          onClick={() => onCambio(p)}
          data-testid={`pp-plan-${id}-${p.va}`}
        >
          <b>{p.label}</b>
          <span>{`${fmtPesos(p.prima)} al mes`}</span>
        </button>
      ))}
    </div>
  );
};
